import axios from "axios";
import {
  SpaceUserEnableInterface,
  SpaceUserPermissionsInterface,
} from "@/resources/interfaces/spaceUserInterfaces";

export default class SpaceUserService {
  async getSpacesUsers(superSpaceId: number, page: number): Promise<any> {
    return await axios.get(
      `api/super_space_users/list?superSpace=${superSpaceId}&page=${page}&order[connectionStatus]=DESC&order[user.name]=ASC&order[user.lastName]=ASC`
    );
  }
  async getSpacesUsersByOrderNameAndLastName(superSpaceId: number, page: number): Promise<any> {
    return await axios.get(
      `api/super_space_users/list?superSpace=${superSpaceId}&page=${page}&order[user.name]=ASC&order[user.lastName]=ASC`
    );
  }
  async getSpacesUsersByOrderNameAndLastNameNoGuest(superSpaceId: number, page: number): Promise<any> {
    return await axios.get(
      `api/super_space_users/list?superSpace=${superSpaceId}&page=${page}&order[user.name]=ASC&order[user.lastName]=ASC&user.isGuest=false`
    );
  }
  async getUsers(
    spaceId: number,
    page: number,
    search: string,
    permision: string
  ): Promise<any> {
    return await axios.get(
      `api/space_users?space=${spaceId}&page=${page}${search}${permision}&order[superSpaceUser.user.name]=ASC&order[superSpaceUser.user.lastName]=ASC`
    );
  }
  async getSpaceUsersInWebinar(
    roomId: number,
    page: number,
    search: string
  ): Promise<any> {
    return await axios.get(
      `api/space_users/room/${roomId}/users_connected?page=${page}${search}`
    );
  }
  async getNumberOfUsersInWebinar(roomId: number) {
    return await axios.get(
      `api/space_users/room/${roomId}/users_connected_counter`
    );
  }
  async searchSpaceUser(
    superSpaceId: number,
    name: string,
    page
  ): Promise<any> {
    return await axios.get(
      `api/super_space_users/list?superSpace=${superSpaceId}&search=${name}${
        page ? `&page=${page}` : ``
      }&order[connectionStatus]=DESC&order[user.name]=ASC&order[user.lastName]=ASC`
    );
  }
  async searchUserTag(superSpaceId, type, search): Promise<any> {
    return await axios.get(`/api/super_space_users/list/filters?superSpace=${superSpaceId}&${type}=${search}&order[connectionStatus]=DESC&order[user.name]=ASC&order[user.lastName]=ASC`);
  }
  /* async getAllSpacesUser(spaceId: number): Promise<any> {
    return await axios.get(
      `api/space_users?space=${spaceId}&pagination=false?order[superSpaceUser.user.name]=ASC&order[superSpaceUser.user.lastName]=ASC`
    );
  } */
  async getUsersOnlineInSpace(spaceId: number): Promise<any> {
    return await axios.get(
      `api/space_users/space/${spaceId}/users_to_draw?order[superSpaceUser.user.name]=ASC&order[superSpaceUser.user.lastName]=ASC`
    );
  }
  async updateSpaceUserPermissions(
    spaceId: number,
    data: SpaceUserPermissionsInterface
  ): Promise<any> {
    return await axios.put(`api/space_users/${spaceId}/give_permissions`, data);
  }
  async updateCollectionSpaceUserPermissions(data): Promise<any> {
    return await axios.put(`api/space_users/give_permissions`, data);
  }
  async enableSpaceUser(
    spaceId: number,
    data: SpaceUserEnableInterface
  ): Promise<any> {
    return await axios.put(`api/space_users/${spaceId}/enable`, data);
  }

  async deleteSpaceUser(spaceUserId: number): Promise<any> {
    return await axios.delete(`/api/space_users/${spaceUserId}`);
  }

  async getMoveToRoom(spaceId: number): Promise<any> {
    return await axios.get(`api/space_users/space/${spaceId}/move_to_room`);
  }
  
  async updateSpaceUserHostPermissions(
    spaceId: number,
    data: SpaceUserPermissionsInterface
  ): Promise<any> {
    return await axios.put(`api/space_users/${spaceId}/give_webinar_host_permission`, data);
  }

  async setReserveRoom(roomId: number, data: any) {
    return await axios.post(`api/rooms/${roomId}/reserve`, data);
  }

  async getSpaceReservations(spaceId: number) {
    return await axios.get(`api/spaces/${spaceId}/room_reservations`,);
  }

  async getRoomReservations(roomId: number, date: string) {
    return await axios.get(`api/rooms/${roomId}/room_reservations?date=${date}`);
  }

  async getReserve(reserveId: number) {
    return await axios.get(`api/room_reservations/${reserveId}`);
  }

  async removeReserve(reserveId: number) {
    return await axios.delete(`api/room_reservations/${reserveId}`);
  }

  async updateReserve(reserveId: number, data: any) {
    return await axios.put(`api/room_reservations/${reserveId}`, data);
  }

  async getSpacePhysicalReservations(superSpaceId: number) {
    return await axios.get(`api/office/super_space/${superSpaceId}/room_reservations`,);
  }
  
  async setReservePhysicalRoom(roomId: number, data: any) {
    return await axios.post(`api/office/room/${roomId}/reserve`, data);
  }

  async getPhysicalRoomReservations(roomId: number, date: string) {
    return await axios.get(`api/office/room/${roomId}/room_reservations?date=${date}`);
  }

  async getPhysicalReserve(reserveId: number) {
    return await axios.get(`api/office/room_reservations/${reserveId}`);
  }

  async removePhysicalReserve(reserveId: number) {
    return await axios.delete(`api/office/room_reservations/${reserveId}`);
  }

  async updatePhysicalReserve(reserveId: number, data: any) {
    return await axios.put(`api/office/room_reservations/${reserveId}`, data);
  }
}
